import { ThemeConfig } from '../core/App/theme';
import { useTheme as useRaTheme } from 'react-admin';

function useTheme() {
  const [theme] = useRaTheme();
  return theme as ThemeConfig;
}

export default useTheme;
